<template>
    <div class="animated fadeIn">
        <b-card header-tag="header">
            <div slot="header">
                <i class="icon-credit-card"></i> Bancos
                <b-link :to="actionUri" class="btn mr-2 btn-sm btn-primary float-right">
                <i class="fa fa-angle-left"></i>
                  Voltar
                </b-link>
            </div>
            <b-card-body>
                <form @submit.prevent="validate" class="needs-validation" novalidate>
                    <div class="form-row">
                        <div class="col-sm-2">
                            <base-input label="Código" required type="tel" placeholder="Digite o codigo" v-model="model.code" v-validate="modelValidations.code" data-vv-name="code" data-vv-as="código" maxlength="3" :mask="['###']" :error="getError('code')" />
                        </div>
                        <div class="col-sm-10">
                            <base-input label="Nome" required type="text" placeholder="Digite seu nome" v-model="model.name" v-validate="modelValidations.name" data-vv-name="name" data-vv-as="nome" maxlength="150" :error="getError('name')"/>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-12">
                            <base-input label="ISPB" required type="tel" placeholder="Digite o ISPB" v-model="model.ispb" v-validate="modelValidations.ISPB" data-vv-name="ISPB" data-vv-as="ISPB" maxlength="50" :mask="['########']" :error="getError('name')"/>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-primary">Salvar</button>
                </form>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
import helperService from '../../../services/Helper/helperService'
import domainService from '../../../services/Bank/bankService'
import editPage from '../../../mixins/editPage'
export default {
    props: {
        id: String
    },
    mixins: [editPage],
    data() {
        return {
            actionUri: '/platform/banks',
            model: {
                name: '',
                id: 0,
                code: null,
                ISPB: ''
            },
            modelValidations: {
                name: {
                    required: true,
                    max: 150
                },
                code: {
                    required: true
                },
                ISPB: {
                    required: true,
                    max: 50
                }
            }
        }
    },
    computed: {
        action() {
            return this.$route.name
        }
    },
    created(){
        this.fetchData()
    },
    methods: {
        fetchData() {
            if(this.action == 'edit_bank') {
                const self = this
                self.showLoading()
                domainService.find(this.id).then((response) =>{
                    self.model = response.data
                    self.hideLoading()
                }, () => {
                    self.hideLoading()
                })
            }
        },
        validate() {
            const self = this
            self.showLoading()
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    if(this.action == 'new_bank') {
                        domainService.create(self.model).then(() => {
                            self.hideLoading()
                            self.$router.push({ path:self.actionUri})
                        })
                    }
                    else {
                        self.model.id = self.id
                        domainService.update(self.model).then(() => {
                            self.hideLoading()
                            self.$router.push({ path: self.actionUri})
                        })
                    }
                } 
                else 
                {
                    self.hideLoading()
                }
            })
        }
    }
}
</script>
